import { NestedMenuItemOption } from 'ui/menu';
import { useTranslation } from 'modules/domains/list';

import { useListTypeMenuOptions } from './useListTypeMenuOptions';

export const useListTypeMenu = (): NestedMenuItemOption => {
  const { t } = useTranslation();
  const listTypeMenuOptions = useListTypeMenuOptions();
  return {
    id: 'listType',
    label: t('indexPage.filters.dropdown.menus.listType.title') ?? '',
    isSelectMenu: true,
    options: listTypeMenuOptions,
  };
};
